import { useEffect, useRef } from "react";
import ScratchCardCanvas from "./ScratchCardCanvas";

export default function ResponsiveScratchCard({ settings, children }) {
  const containerRef = useRef(null);

  // Keep cover calibrated on resize
  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;
    const ro = new ResizeObserver(() => {});
    ro.observe(node);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        borderRadius: "9999px",
        overflow: "hidden",
      }}
    >
      <ScratchCardCanvas
        brushSize={settings?.brushSize ?? 22}
        finishPercent={settings?.finishPercent ?? 70}
        onComplete={settings?.onComplete}
        coverColor={settings?.coverColor ?? "#D9D9D9"}
        coverImage={settings?.coverImage}
      >
        {children ? (
          children
        ) : settings?.image ? (
          <div className="flex h-full w-full items-center justify-center bg-white">
            <img
              src={settings.image}
              alt={settings?.imageAlt || "reward"}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-white" />
        )}
      </ScratchCardCanvas>
    </div>
  );
}


